<div [ngClass]="{ 'cursor-progress': waiting, 'cursor-default': !waiting }">
  @if (!useNewCard) {
    <div>
      <div class="form form-inline">
        @if (!showCards && selectedSource !== undefined) {
          <div>
            @if (title) {
              <div class="title-heading text-center" (click)="onHeadingClick($event)">{{title}}</div>
            }
            <div class="selected-source">
              <i class="fa fa-2x {{ brandIcon(selectedSource.brand) }}" style="padding: 10px; vertical-align: middle; color: teal"></i>
              <span>
                <strong>{{ selectedSource.brand }}</strong>
                <span class="hidden-xs text-margin-right"> ending in</span>
                <strong>*{{ selectedSource.last4 }}</strong>
                <span class="hidden-xs text-margin-right"> - expires</span>
                <strong>{{ renderExpLabel(selectedSource) }}</strong>
              </span>
              <button id="change-payment-method-button" class="btn btn-primary hvr-push" (click)="onChangePaymentMethodClick()">
                Change
              </button>
            </div>
          </div>
        }
        <!-- The cards that are displayed after the user clicks the "Change" link/button. -->
        @if (showCards) {
          <div>
            <h4 class="heading" (click)="onHeadingClick($event)">Choose Payment Method</h4>
            <div style="text-align: right">
              <button id="close-payment-method-button" class="btn btn-primary hvr-push" (click)="onCloseClick()">Close</button>
            </div>
            @for (source of sources; track source) {
              <div>
                <payment-method-horizontal
                  [source]="source"
                  [showSelectInput]="true"
                  [isSelected]="isSourceChecked(source)"
                  (click)="onSourceClick($event)"
                  >
                </payment-method-horizontal>
              </div>
            }
            <div>
              <div class="credit-card">
                <i class="fa fa-plus" style="vertical-align: middle; margin-right: 10px"></i>
                <button id="stripe-wallet-add-new-card" class="btn btn-primary hvr-push" (click)="showNewCard()">Add new card</button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
  @if (useNewCard) {
    <div>
      <stripe-form #stripeForm [errorMessage]="errorMessage"></stripe-form>
      <div style="margin-top: 1em">
        <button
          id="stripe-wallet-add-card"
          class="btn btn-primary hvr-push"
          (click)="onAddCardClick($event)"
          [disabled]="!addCardEnabled"
          >
          Add Card
        </button>
        <button
          id="stripe-wallet-cancel-add-card"
          class="btn btn-default hvr-push"
          (click)="onCancelAddNewCardClick()"
          [disabled]="!addCardEnabled"
          >
          Cancel
        </button>
      </div>
    </div>
  }
</div>
